import { Layout } from "components"
import Config from "config"
import NotFound from "pages/404"
import Dashboard from "pages/Dashboard"
import Login from "pages/Login"
import { memo, useContext } from "react"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom"
import { AuthContext } from "utilities"
import { NotifContextProvider } from "utilities/Context"

const MyRoutes = () => {
  const { state } = useContext(AuthContext)
  const { isAuthenticated, role } = state
  const { ROUTES } = Config

  const AuthRoutes = memo(({ setNavbarTitle }) => {
    return (
      <Switch>
        {/* DASHBOARD */}
        <Route exact path="/">
          <Dashboard setNavbarTitle={setNavbarTitle} />
        </Route>

        {/* ROUTES */}
        {ROUTES.map(
          (val, index) =>
            val.hak &&
            val.hak.some((hak) => role.includes(hak)) && (
              <Route key={index} exact={val.exact} path={val.path}>
                <val.page setNavbarTitle={setNavbarTitle} />
              </Route>
            )
        )}

        {/* LOGIN FORM */}
        <Route path="/login">
          <Redirect to="/" />
        </Route>

        {/* 404-NOT FOUND */}
        <Route path="*">
          <NotFound setNavbarTitle={setNavbarTitle} />
        </Route>
      </Switch>
    )
  })

  // Routes pada saat belum terotentikasi
  const UnAuthRoutes = () => (
    <Switch>
      <Route exact path="/login">
        <Login />
      </Route>
      <Route path="*">
        <Redirect to="/login" />
      </Route>
    </Switch>
  )

  // Routing keseluruhan
  const Routes = () => {
    if (!isAuthenticated) {
      return <UnAuthRoutes />
    }

    return (
      <Layout>
        <AuthRoutes />
      </Layout>
    )
  }

  return (
    <NotifContextProvider>
      <BrowserRouter basename="/">
        <Routes />
      </BrowserRouter>
    </NotifContextProvider>
  )
}

export default MyRoutes
